<template>
  <img src="../assets/infoicon.svg" class="infoicon" v-b-popover.hover="text"/>
</template>

<script>
export default {
    props: {
        text: String
    }
}
</script>

<style>
    .infoicon {
        height:18px;
        position:relative;
        top:-5px;
    }
</style>